module.exports = __webpack_public_path__ + "img/typhoon_32_1.3ee8e44a.jpg";